import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Icon24 from 'builder/components/Icon'

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  gap: 4px;
  padding: 0 12px 12px;
`

export const TextContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const SettingsIcon = styled(Icon24.Settings2)`
  color: ${Colors.Neutral90};
`

export const FaqIcon = styled(Icon24.Info)`
  color: ${Colors.Neutral90};
`

export const LogOutIcon = styled(Icon24.LogOut)`
  color: ${Colors.Neutral90};
`

export const Link = styled.a`
  display: flex;
  gap: 8px;
  border-radius: 8px;
  align-items: center;
  cursor: pointer;
  color: ${Colors.Neutral90};
  transition: color 0.2s;
  cursor: pointer;
  border: none;
  background: none;
  margin: 0;
  padding: 0;
  text-align: start;
  width: 100%;
  padding: 8px;

  &:hover {
    background-color: ${Colors.Neutral5};
  }
`
